import { createApi } from 'swag-client-common/libs/rapi';
export const CategoryApi = createApi({
  getAll: {
    url: '/api/v1/category?hideEmptyCategories=true',
    method: 'get'
  }
});